import {
  REQUEST_FR_LIST,
  RECEIVE_FR_LIST,
  ERROR_FR_LIST,

  REQUEST_FR_TEAMLEADERS,
  RECEIVE_FR_TEAMLEADERS,
  ERROR_FR_TEAMLEADERS,

  REQUEST_MINIMAL_FIELD_REP_LIST,
  RECEIVE_MINIMAL_FIELD_REP_LIST,
  ERROR_MINIMAL_FIELD_REP_LIST,

  REQUEST_FIELD_REP_DEVELOPMENT_MANAGER_LIST,
  RECEIVE_FIELD_REP_DEVELOPMENT_MANAGER_LIST,
  ERROR_FIELD_REP_DEVELOPMENT_MANAGER_LIST,

  REQUEST_MINIMAL_FIELD_REP_LIST_FOR_CASE,
  RECEIVE_MINIMAL_FIELD_REP_LIST_FOR_CASE,
  ERROR_MINIMAL_FIELD_REP_LIST_FOR_CASE,

  REQUEST_FIELD_REP_MANAGERS,
  RECEIVE_FIELD_REP_MANAGERS,
  ERROR_FIELD_REP_MANAGERS,

  REQUEST_INSPECTOR_LIST_SUMMARY,
  RECEIVE_INSPECTOR_LIST_SUMMARY,
  ERROR_INSPECTOR_LIST_SUMMARY,

  REQUEST_FR_EXCLUSION_SEARCH_RESULTS,
  RECEIVE_FR_EXCLUSION_SEARCH_RESULTS,
  ERROR_FR_EXCLUSION_SEARCH_RESULTS,
} from 'typeConstants';
import { fieldRep as initialState } from '../initialState.tsx';

const fieldRep = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FR_LIST:
      return {
        ...state,
        isFetchingFieldReps: true
      };
    case RECEIVE_FR_LIST:
      return {
        ...state,
        isFetchingFieldReps: false,
        fieldRepsDetailed: action.payload
      };
    case ERROR_FR_LIST:
      return {
        ...state,
        isFetchingFieldReps: true
      };
    case REQUEST_FR_TEAMLEADERS:
      return {
        ...state,
        isFetchingAllTeamLeaders: true
      };
    case RECEIVE_FR_TEAMLEADERS:
      return {
        ...state,
        isFetchingAllTeamLeaders: false,
        allTeamLeaders: action.payload
      };
    case ERROR_FR_TEAMLEADERS:
      return {
        ...state,
        isFetchingAllTeamLeaders: false
      };
    case REQUEST_MINIMAL_FIELD_REP_LIST:
      return {
        ...state,
        isFetchingFieldReps: true
      };
    case RECEIVE_MINIMAL_FIELD_REP_LIST:
      return {
        ...state,
        isFetchingFieldReps: false,
        fieldRepsBasic: action.payload
      };
    case ERROR_MINIMAL_FIELD_REP_LIST:
      return {
        ...state,
        isFetchingFieldReps: false
      };
    case REQUEST_FIELD_REP_DEVELOPMENT_MANAGER_LIST:
      return {
        ...state,
        isFetchingFieldDevelopmentManagers: true
      };
    case RECEIVE_FIELD_REP_DEVELOPMENT_MANAGER_LIST:
      return {
        ...state,
        isFetchingFieldDevelopmentManagers: false,
        fieldRepDevelopmentManagers: action.payload
      };
    case ERROR_FIELD_REP_DEVELOPMENT_MANAGER_LIST:
      return {
        ...state,
        isFetchingFieldDevelopmentManagers: false
      };
    case REQUEST_MINIMAL_FIELD_REP_LIST_FOR_CASE:
      return {
        ...state,
        isFetchingFieldReps: true
      };
    case RECEIVE_MINIMAL_FIELD_REP_LIST_FOR_CASE:
      return {
        ...state,
        fieldRepsBasicByCase: action.payload,
        isFetchingFieldReps: false
      };
    case ERROR_MINIMAL_FIELD_REP_LIST_FOR_CASE:
      return {
        ...state,
        isFetchingFieldReps: false
      };
    case REQUEST_FIELD_REP_MANAGERS:
      return {
        ...state,
        isFetchingFieldRepManagers: true,
      };
    case RECEIVE_FIELD_REP_MANAGERS:
      return {
        ...state,
        fieldRepManagers: action.payload,
        isFetchingFieldRepManagers: false,
      };
    case ERROR_FIELD_REP_MANAGERS:
      return {
        ...state,
        isFetchingFieldRepManagers: false,
      };
    case REQUEST_INSPECTOR_LIST_SUMMARY:
      return {
        ...state,
        isFetchingTimeLogSummary: true,
      };
    case RECEIVE_INSPECTOR_LIST_SUMMARY:
      return {
        ...state,
        timeLogSummaryList: action.payload,
        isFetchingTimeLogSummary: false,
      };
    case ERROR_INSPECTOR_LIST_SUMMARY:
      return {
        ...state,
        isFetchingTimeLogSummary: false,
      };
    case REQUEST_FR_EXCLUSION_SEARCH_RESULTS:
      return {
        ...state,
        fetchingExclusionSearchResults: true,
      };
    case RECEIVE_FR_EXCLUSION_SEARCH_RESULTS:
      return {
        ...state,
        fetchingExclusionSearchResults: false,
        exclusionSearchResults: action.payload,
      };
    case ERROR_FR_EXCLUSION_SEARCH_RESULTS:
      return {
        ...state,
        fetchingExclusionSearchResults: false,
      };
    default:
      return state;
  }
};

export default fieldRep;
